import React from 'react'

export default function HeroSection() {
  return (
    <div>HeroSection</div>
  )
}
